import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import "./workTimeTag.scss";

interface IWorkTimeTagProps extends ComponentPropsWithoutRef<"span"> { }

export const WorkTimeTag = (props: IWorkTimeTagProps) => {
    return <span {...props} className={clsx("work-time-tag", props.className)} />;
};
